import React, { useState } from "react";
import { CardContent, Grid } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import useGetUserContractsByHierarchy from "../../hooks/useGetUserContractsByHierarchy";
import { CardPageItem } from "../../custom/Page";
import { useSelector } from "react-redux";
import LoadingSpinner from "./LoadingSpinner";
import ErrorMessage from "./ErrorMessage";
import MultiSelectDropdowm from "./select/base/MultiSelectDropdown";
import FooterFinancialSummary from "./UserContractsOverview/FooterFinancialSummary";
import ContractList from "./UserContractsOverview/ContractList";
import LocaleNumberField from "./LocaleNumberField";
import { debounce } from "../../util";

const types = [
  { label: "app.enuns.OPEN", value: "OPEN" },
  { label: "app.enuns.CLOSED", value: "CLOSED" },
];

const UserContractsOverview = ({ user, showCommissionValue }) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const [searchId, setSearchId] = useState("");
  const [typeSelected, setTypeSelected] = useState([]);

  const handleSearchId = debounce((value) => {
    setSearchId(value);
  }, 1000);

  const { commissionGenerated, summary, loading, error } = useGetUserContractsByHierarchy({ userId: user.id, contractId: searchId, types: typeSelected });

  return (
    <>
      <CardPageItem
        raised
        margin={1}
        style={{ margin: "8px 0" }}
      >
        <CardContent>
          <Grid
            container
            spacing={1}
          >
            <Grid
              item
              xs={12}
              sm={5}
              md={6}
            >
              <LocaleNumberField
                fullWidth
                label="app.search.contractId"
                value={searchId}
                decimalPlaces={0}
                setValue={handleSearchId}
                checkEmptyError={false}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={7}
              md={6}
            >
              <MultiSelectDropdowm
                title="app.contractTypes"
                values={types}
                onChange={(values) => setTypeSelected(values)}
              />
            </Grid>
          </Grid>
        </CardContent>
      </CardPageItem>

      {loading ? (
        <LoadingSpinner message={<FormattedMessage id="app.loading.fetching.contracts" />} />
      ) : error ? (
        <ErrorMessage>
          <FormattedHTMLMessage
            defaultMessage={error}
            id={error}
          />
        </ErrorMessage>
      ) : (
        <ContractList
          contracts={summary?.contracts ?? []}
          currentUser={currentUser}
        />
      )}
      <FooterFinancialSummary
        showCommissionValue={showCommissionValue}
        hiddenValues={currentUser.hideValues}
        summary={summary}
        commissionGenerated={commissionGenerated}
      />
    </>
  );
};

export default UserContractsOverview;
